<script setup>
import { ref, computed } from 'vue'
import { useUserInventory } from '../composables/UserInventory.js'

const emit = defineEmits([ "escape" ]);

const {
  privateTrays,
  userItems,
  isAutoUserItems,
  isUserItemsVisible,
  autoSelectPrivateTray,
  emitUserInventory,
} = useUserInventory();

function escape() {
  emit("escape");
}

function showUserItemModal(row) {
  emitUserInventory("showUserItemModal", row);
}
</script>

<template>
  <!-- User's items list -->
  <div class="mb-8 pb-8 h-[800px]">

    <!-- Back button navigation -->
    <div class="mt-0 dark:text-gray-400" v-if="!isAutoUserItems">
      <Button type="primary" @click="() => escape()"><i class="fa fa-arrow-left"></i></Button>
      <span class="ml-4 text-lg font-normal">Nazaj na katalog</span>
    </div>

    <div class="dark:text-gray-400" :class="{ 'mt-8': !isAutoUserItems }">
      <span class="text-lg font-medium">Uporabnikovi predali in izposojeni artikli</span>
      <span class="pl-2 relative" style="bottom: 1px" v-if="!autoSelectPrivateTray && privateTrays?.length">({{ privateTrays.length }})</span>
      <!-- <div class="text-md">Seznam trenutno zasedenih osebnih predalov in izposojenih artiklov s strani uporabnika</div> -->
    </div>

    <!-- Display mode: list -->
    <div class="relative grid grid-cols-1 gap-4 w-full mt-2 mb-2" v-if="userItems?.length > 0">

      <!-- List private trays -->
      <div v-if="userItems.filter(x => x.type == 'private').length" class="flex flex-col gap-2">
        <div class="text-md">Seznam osebnih predalov v uporabi</div>
        <a href="#" v-for="(row, i) in userItems.filter(x => x.type == 'private')" @click.prevent="showUserItemModal(row)" class="py-4 flex bg-white border border-gray-200 rounded-lg shadow hover:border-blue-600 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
          <template v-if="row.type == 'private' && row.privateTray">

            <!-- Status icon -->
            <div class="grid place-items-center text-gray-200 dark:text-gray-400 text-center w-24 mx-4"
              :class="{
                'text-gray-300 dark:text-gray-400': row.privateTray.status == 'locked',
                'text-red-500 dark:text-red-600': row.privateTray.status == 'occupied' && row.privateTray.userId != currentUserId,
                'text-blue-500 dark:text-blue-500': row.privateTray.status == 'occupied' && row.privateTray.userId == currentUserId,
                'text-green-500 dark:text-green-500': row.privateTray.status == 'active'
              }" style="font-size: 32px; width: 50px; height: 50px;">
              <i class="fa fa-user" :class="{ 'text-blue-500 dark:text-blue-500': row.privateTray.status == 'occupied' && row.privateTray.userId == currentUserId }" v-if="row.privateTray.status == 'occupied' || row.privateTray.userId == currentUserId"></i>
              <i class="fa fa-lock" v-else-if="row.privateTray.status == 'locked'"></i>
              <i class="fa fa-inbox" v-else-if="row.privateTray.status == 'active'"></i>
            </div>

            <!-- Tray name -->
            <div class="w-full pr-5 flex flex-row justify-between items-center gap-2">
              <div>
                <h5 class="text-md tracking-tight text-gray-900 dark:text-white" v-if="row.privateTray.name">Predal <strong>{{ row.privateTray.name }}</strong> <span v-if="row.privateTray.cabinetName">na omari <strong>{{ row.privateTray.cabinetName }}</strong></span></h5>
                <h3 class="mt-0 text-blue-500" v-if="row.privateTray.status == 'occupied' && row.privateTray.userId == currentUserId">Osebni predal</h3>
              </div>
            </div>

          </template>
        </a>
      </div>

      <!-- List borrowed articles -->
      <div v-if="userItems.filter(x => x.type == 'article').length" class="flex flex-col gap-2">
        <div class="text-md">Seznam izposojenih artiklov</div>
        <a href="#" v-for="(row, i) in userItems.filter(x => x.type == 'article')" @click.prevent="showUserItemModal(row)" class="py-4 flex bg-white border border-gray-200 rounded-lg shadow hover:border-blue-600 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
          <template v-if="row.type == 'article' && row.articleItem">

            <!-- Article image -->
            <div class="grid place-items-center text-center w-24 mx-4 dark:bg-white dark:p-1 dark:rounded-md" style="max-height: 50px" v-if="row.articleItem.thumbnailUrl">
              <img :src="row.articleItem.thumbnailUrl" alt="" class="w-full aspect-square" style="max-width: 50px;" />
            </div>
            <!-- <div class="grid place-items-center text-center w-24 mx-4" style="width: 50px; height: 50px" v-else-if="allowImageFallback && currentCategoryImageUrl">
              <img :src="currentCategoryImageUrl" alt="" style="max-width: 50px; max-height: 50px;" />
            </div> -->
            <!-- <div class="grid place-items-center text-center w-24 mx-4" style="width: 50px; height: 50px" v-else-if="allowImageFallback && nearestParentCategorySmallImageUrl">
              <img :src="nearestParentCategorySmallImageUrl" alt="" style="max-width: 50px; max-height: 50px;" />
            </div> -->
            <div class="grid place-items-center text-gray-200 dark:text-gray-900 text-center w-24 mx-4" :class="{ 'text-blue-200': selectedItemId == row.articleItem.id }" style="font-size: 48px; width: 50px; height: 50px;" v-else>
              <i class="fa fa-image"></i>
            </div>

            <!-- Article name and SKU -->
            <div class="w-full pr-5 flex flex-row justify-between items-center gap-2">
              <div>
                <h5 class="text-md tracking-tight text-gray-900 dark:text-white" v-if="row.articleItem.name">{{ row.articleItem.name }}</h5>
                <h3 class="mt-0 text-slate-400" v-if="row.articleItem.sku">{{ row.articleItem.sku }}</h3>
              </div>
              <!-- <div v-if="row.articleItem.totalQuantity > 0">
                <h5 class="text-gray-500">{{ row.articleItem.totalQuantity }}&nbsp;kos</h5>
                <h3 v-if="row.articleItem.sku">&nbsp;</h3>
              </div> -->
            </div>

            <!-- Tray name -->
            <!-- <div class="w-full pr-5 flex flex-row justify-between items-center gap-2">
              <div>
                <h5 class="text-md tracking-tight text-gray-900 dark:text-white" v-if="row.articleItem.name">{{ row.articleItem.name }}</h5>
                <h3 class="mt-0 text-blue-500" v-if="row.articleItem.status == 'occupied' && row.userId == currentUserId">Osebni predal</h3>
              </div>
            </div> -->

          </template>
        </a>
      </div>

      <!-- List articles for transfer -->
      <div v-if="userItems.filter(x => x.type == 'transfer').length" class="flex flex-col gap-2">
        <div class="text-md">Seznam artiklov za prenos</div>
        <a href="#" v-for="(row, i) in userItems.filter(x => x.type == 'transfer')" @click.prevent="showUserItemModal(row)" class="py-4 flex bg-white border border-gray-200 rounded-lg shadow hover:border-blue-600 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
          <template v-if="row.type == 'transfer' && row.articleItem">

            <!-- Article image -->
            <div class="grid place-items-center text-center w-24 mx-4 dark:bg-white dark:p-1 dark:rounded-md" style="max-height: 50px" v-if="row.articleItem.thumbnailUrl">
              <img :src="row.articleItem.thumbnailUrl" alt="" class="w-full aspect-square" style="max-width: 50px;" />
            </div>
            <!-- <div class="grid place-items-center text-center w-24 mx-4" style="width: 50px; height: 50px" v-else-if="allowImageFallback && currentCategoryImageUrl">
              <img :src="currentCategoryImageUrl" alt="" style="max-width: 50px; max-height: 50px;" />
            </div> -->
            <!-- <div class="grid place-items-center text-center w-24 mx-4" style="width: 50px; height: 50px" v-else-if="allowImageFallback && nearestParentCategorySmallImageUrl">
              <img :src="nearestParentCategorySmallImageUrl" alt="" style="max-width: 50px; max-height: 50px;" />
            </div> -->
            <div class="grid place-items-center text-gray-200 dark:text-gray-900 text-center w-24 mx-4" :class="{ 'text-blue-200': selectedItemId == row.articleItem.id }" style="font-size: 48px; width: 50px; height: 50px;" v-else>
              <i class="fa fa-image"></i>
            </div>

            <!-- Article name and SKU -->
            <div class="w-full pr-5 flex flex-row justify-between items-center gap-2">
              <div>
                <h5 class="text-md tracking-tight text-gray-900 dark:text-white" v-if="row.articleItem.name">{{ row.articleItem.name }}</h5>
                <h3 class="mt-0 text-slate-400" v-if="row.articleItem.sku">{{ row.articleItem.sku }}</h3>
              </div>
              <!-- <div v-if="row.articleItem.totalQuantity > 0">
                <h5 class="text-gray-500">{{ row.articleItem.totalQuantity }}&nbsp;kos</h5>
                <h3 v-if="row.articleItem.sku">&nbsp;</h3>
              </div> -->
            </div>

            <!-- Tray name -->
            <!-- <div class="w-full pr-5 flex flex-row justify-between items-center gap-2">
              <div>
                <h5 class="text-md tracking-tight text-gray-900 dark:text-white" v-if="row.articleItem.name">{{ row.articleItem.name }}</h5>
                <h3 class="mt-0 text-blue-500" v-if="row.articleItem.status == 'occupied' && row.userId == currentUserId">Osebni predal</h3>
              </div>
            </div> -->

            <div class="w-full pr-5 flex flex-row justify-end items-center gap-2">
              <div class="text-right">
                <span class="text-md tracking-tight text-gray-900 dark:text-white">{{ Math.abs(row.articleItem.quantity) || 0 }}</span> kos
                <i class="fa fa-arrow-right-from-bracket text-amber-500 ml-2"></i>
              </div>
            </div>

          </template>
        </a>
      </div>

    </div>

    <!-- No article found -->
    <div class="relative sm:grid sm:grid-cols-1 gap-4 w-full mt-2 mb-2" v-if="!userItems || userItems.length == 0">
      <span class="text-slate-500">Ni zapisov za prikaz.</span>
    </div>
    
    <!-- Continue -->
    <div class="mt-8 dark:text-gray-400 flex justify-end w-full" v-if="isUserItemsVisible && isAutoUserItems">
      <Button type="primary" @click="() => back()">Nadaljuj z uporabo omare</Button>
    </div>

    <!-- Debug -->
    <!-- <pre class="border rounded p-4 bg-amber-100">{{ userItems }}</pre> -->

    <div class="distancer-bottom h-20">
    </div>

  </div>
</template>